import i18n from "utils/i18n";
import PropTypes from "prop-types";
import React from "react";

/**
 * A file selector and submit component
 *
 * @example
 * <FileAndSubmitField className="btn btn-xs btn-default mbs" fileFieldId="avatar_upload" />
 */
class FileAndSubmitField extends React.Component {
  /**
   * Sets the initial state and binds the fileFieldElement change event
   *
   * @param {object} props The passed in properties
   */
  constructor(props) {
    super(props);
    this.state = { working: false };
    this.onClick = this.onClick.bind(this);
    this.onFileFieldChange = this.onFileFieldChange.bind(this);
  }

  /**
   *  Sets up the event listener
   */
  componentDidMount() {
    document.querySelector(`#${this.props.fileFieldId}`).addEventListener("change", this.onFileFieldChange);
  }

  /**
   *  Removes the event listener
   */
  componentWillUnmount() {
    document.querySelector(`#${this.props.fileFieldId}`).removeEventListener("change", this.onFileFieldChange);
  }

  /**
   *  Handle click events
   *
   * @param {object} event The event object
   */
  onClick(event) {
    document.querySelector(`#${this.props.fileFieldId}`).click();

    // Stop the propagation of the click event because it is firing the submit() method for the form
    event.preventDefault();
  }

  /**
   * Handles the change event for the file field
   *
   * @param {object} event The event object
   */
  onFileFieldChange(event) {
    event.currentTarget.form.submit();
    this.setState({ working: true });
  }

  /**
   * Renders the component
   *
   * @returns {object} The React component
   */
  render() {
    return (
      <button className={this.props.className} disabled={this.state.working} onClick={this.onClick} type="button">
        <i className={this.renderIcon()}></i> {i18n.t("global.upload")}
      </button>
    );
  }

  /**
   *  Renders the icon as either a "waiting" icon or a "cloud-upload" icon
   *
   * @returns {string} The icon class
   */
  renderIcon() {
    if (this.state.working) {
      return "fa fa-spinner fa-spin";
    }

    return "fa fa-cloud-upload";
  }
}

FileAndSubmitField.propTypes = {
  className: PropTypes.string,
  fileFieldId: PropTypes.string.isRequired
};

export default FileAndSubmitField;
